<template>
  <div
    v-for="(item, key) in questionList"
    :key="item.TmplId"
    class="question-list"
  >
    <questionItem
      class="list-box"
      :item="item"
      :keys="key"
      :preview="preview"
    />
  </div>
</template>
<script>
  import questionItem from './questionItem.vue'
  export default {
    name: 'QuestionList',
    components: {
      questionItem,
    },
    props: {
      questionList: {
        type: Array,
        default: () => {
          return []
        },
      },
      preview: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      dragOptions() {
        return {
          animation: 600,
          group: 'description',
        }
      },
      // questionList() {
      //   return this.questionList
      // },
    },
    watch: {},
    created() {},
    methods: {},
  }
</script>
<style lang="scss" scoped>
  .question-list {
    position: relative;
    margin: 20px 0 30px;
    &:hover {
      .tools {
        display: block;
      }
    }
    .tools {
      position: absolute;
      right: 20px;
      top: 10px;
      line-height: 1;
      display: none;
      i {
        font-size: 20px;
        // color: #999;
        cursor: pointer;
        margin-left: 10px;
      }
    }
  }
</style>
